// Module
var code = "<page-header title=\"'堆栈列表'\" breadcrumbs=\"['堆栈']\" reload=\"true\"> </page-header>\n\n<docker-stacks-datatable\n  ng-if=\"stacks\"\n  dataset=\"stacks\"\n  is-image-notification-enabled=\"enableImageNotification\"\n  on-remove=\"(removeAction)\"\n  on-refresh=\"(getStacks)\"\n></docker-stacks-datatable>\n";
// Exports
var _module_exports = code;;
var path = 'app/portainer/views/stacks/stacks.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;